import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import './main.styl';

Vue.use(Vuetify, {
  customProperties: true,
  iconfont: 'fa',
  theme: {
    primary: '#6791bf',
    secondary: '#796bb2',
  },
});
